/*!
 * devextreme-angular
 * Version: 22.1.11
 * Build date: Mon Aug 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */

import { PLATFORM_ID, Inject, NgModule } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import ajax from 'devextreme/core/utils/ajax';
import { Deferred } from 'devextreme/core/utils/deferred';
import { TransferState, makeStateKey, BrowserTransferStateModule } from '@angular/platform-browser';

@NgModule({
  imports: [
    BrowserTransferStateModule
  ]
})

export class DxServerTransferStateModule {
    constructor(private state: TransferState, @Inject(PLATFORM_ID) private platformId: any) {
        let that = this;

        ajax.inject({
            sendRequest: function(...args) {
                let key = makeStateKey(that.generateKey(args)),
                    cachedData = that.state.get(key, null as any);

                if (isPlatformServer(that.platformId)) {
                    let result = this.callBase.apply(this, args);
                    result.always((data, status) => {
                        let dataForCache = {
                            data: data,
                            status: status
                        };
                        that.state.set(key, dataForCache as any);
                    });
                    return result;
                } else {
                    if (cachedData) {
                        let d = (Deferred as any)();
                        d.resolve(cachedData.data, cachedData.status);
                        that.state.set(key, null as any);

                        return d.promise();
                    }
                    return this.callBase.apply(this, args);
                }
            }
        });
    }

    generateKey(args) {
        let keyValue = '';
        for (let key in args) {
            if (typeof args[key] === 'object') {
                let objKey = this.generateKey(args[key]);
                keyValue += key + objKey;
            } else {
                keyValue += key + args[key];
            }
        }

        return keyValue;
    }
 }
